<template>
<div class="chapter">
<div class="inner_page">
<div class="sidebarb">
<p class="sidebartitle1"><a id="cat"></a>The Cat Lover’s Year</p>
<p class="noindent2"><img alt="image" class="img" src="images/f0007-01.jpg"/>  <strong>MONDAYS</strong> provide practical information, from welcoming a cat home to understanding his basic needs.</p>
<p class="noindent2"><img alt="image" class="img" src="images/f0007-02.jpg"/>  <strong>TUESDAYS</strong> contain engaging tales of cats in history and in literature.</p>
<p class="noindent2"><img alt="image" class="img" src="images/f0007-03.jpg"/>  <strong>WEDNESDAYS</strong> explore feline health and wellness topics, from acupuncture to the zodiac.</p>
<p class="noindent2"><img alt="image" class="img" src="images/f0007-04.jpg"/>  <strong>THURSDAYS</strong> deliver ideas for cat-friendly home decor, crafts, and household tips for cat lovers.</p>
<p class="noindent2"><img alt="image" class="img" src="images/f0007-05.jpg"/>  <strong>FRIDAYS</strong> introduce a world of cat breeds, from from Abyssinian to York Chocolate.</p>
<p class="noindent2"><img alt="image" class="img" src="images/f0007-06.jpg"/>  <strong>WEEKENDS</strong> are reserved for bonding, relationship building, and planning special occasions with your pet.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cat.vue?8e0ef452